export const hasOfferActivePromotions = (offer: object) => "has_active_promotions" in offer && !!offer.has_active_promotions;
